import { createFileRoute } from "@tanstack/react-router";
import { LANDING_CONTENT } from "@/features/landing/content";
import { Landing } from "@/features/landing/Landing";
import { i18n } from "@/lib/i18n";
import { buildHead } from "@/lib/seo/head";
import { siteUrl } from "@/lib/seo/siteUrl";

// `/` is the conversion landing (ADR-0040): the funnel's first stage and the
// SEO / social entry point. The wow 3D hero hooks; the crawlable proof stack
// below it closes. Its CTAs lead to /upload, the drop-on-Stage studio where the
// funnel actually begins.
//
// This is the single route prerendered to static HTML in the SEO tracer bullet
// (ADR-0053 §1, #354): `ssr: true` opts it into build-time server rendering while
// the WebGL/browser-only routes stay client-only (the app default under SPA
// mode). Its `head` builds the full SEO head model (title, description, canonical,
// Open Graph, Twitter, Organization + WebSite JSON-LD) via the pure `buildHead`
// (#355) — baked into the prerendered `<head>`, replacing the runtime `useEffect`
// hook that non-JS social scrapers never saw. Every URL is absolute, derived from
// the per-environment build-time `SITE_URL`; the Product/Offer node is gated on a
// real price (ADR-0053 §5), which the MVP does not have yet, so it is omitted.
export const Route = createFileRoute("/")({
  ssr: true,
  head: () =>
    buildHead({
      path: "/",
      locale: i18n.resolvedLanguage ?? "pl",
      siteUrl: siteUrl(),
      content: {
        title: i18n.t("landing:meta.title"),
        description: i18n.t("landing:meta.description"),
        image: {
          path: LANDING_CONTENT.hero.poster.src,
          alt: i18n.t("landing:meta.ogImageAlt"),
        },
        twitterCard: "summary_large_image",
        // The existing price gate (content.ts): no fabricated price in the MVP, so
        // the Offer ships ONLY once `pricing.price` is a real number.
        product:
          LANDING_CONTENT.pricing.price != null
            ? {
                price: LANDING_CONTENT.pricing.price,
                currency: LANDING_CONTENT.pricing.currency,
              }
            : null,
      },
    }),
  component: Landing,
});
